/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_viewer" | "PdpSharedBlurbSupportNumber_viewer">;
    readonly " $refType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$data = PdpRespSidebarBlurbs_viewer;
export type PdpRespSidebarBlurbs_viewer$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '4fcd71bbf85c2f008a36812dee022a0e';
export default node;
